import { annuallyOn, annuallyOnTime } from './annually-on';
import { daily, dailyTime } from './daily';
import { lastDayInMonth, lastDayInMonthTime } from './last-day-in-month';
import { noRepeat, noRepeatTime } from './no-repeat';
import { nthDayInMonth, nthDayInMonthTime } from './nth-day-in-month';
import { sameDayInMonth, sameDayInMonthTime } from './same-day-in-month';
import { weekDayTime, weekday } from './weekday';
import { weeklyOn, weeklyOnTime } from './weekly-on';

export const displaySolvers = {
  noRepeat: noRepeat,
  daily: daily,
  weeklyOn: weeklyOn,
  weekday: weekday,
  sameDayInMonth: sameDayInMonth,
  nthDayInMonth: nthDayInMonth,
  lastDayInMonth: lastDayInMonth,
  annuallyOn: annuallyOn
};

export const timeSolvers = {
  noRepeat: noRepeatTime,
  daily: dailyTime,
  weeklyOn: weeklyOnTime,
  weekday: weekDayTime,
  sameDayInMonth: sameDayInMonthTime,
  nthDayInMonth: nthDayInMonthTime,
  lastDayInMonth: lastDayInMonthTime,
  annuallyOn: annuallyOnTime
};
